module.exports = __webpack_public_path__ + "static/img/empty.8b85a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/empty.png
// module id = WwxF
// module chunks = 1